import { isSSR } from '../utils/isSSR';

/**
 * с хотсами пока что так. позже забрать идею из site-app c HostsCustomizer и довести её до рабочего состояния
 */

export const ADS_HOST_NAME = isProd ? 'ads.sletat.ru' : 'adsdebug.sletat.ru';
export const AGENT_HOST_NAME = isProd ? 'agent.sletat.ru' : 'agentdebug.sletat.ru';
export const B2B_HOST_NAME = isProd ? 'pro.sletat.ru' : 'prodebug.sletat.ru';
export const CB_HOST_NAME = isProd ? 'api-cb.sletat.ru' : 'api-cbdebug.sletat.ru';
export const CLAIMS_HOST_NAME = isProd ? 'claims.sletat.ru' : 'claimsdebug.sletat.ru';
export const CURRENCY_HOST_NAME = isProd ? 'currency.sletat.ru' : 'currencydebug.sletat.ru';
export const GRAPH_HOST_NAME = isProd ? 'graph.sletat.ru' : 'graphdebug.sletat.ru';
export const LEADHUB_HOST_NAME = isProd ? 'leadhub.sletat.ru' : 'leadhubdebug.sletat.ru';
export const MODULE_HOST_NAME = isProd ? 'module.sletat.ru' : 'moduledebug.sletat.ru';
export const MODULE_SETTINGS_HOST_NAME = isProd ? 'modulesettings.sletat.ru' : 'modulesettingsdebug.sletat.ru';

export const SLETAT_HOST_NAME_PRIVATE = isProd ? 'site.global.sletat.ru' : 'debug.global.sletat.ru';
export const SLETAT_HOST_NAME_PUBLIC = isProd ? 'sletat.ru' : 'debug.sletat.ru';

/** Use for SSR requests only! */
export const getSletatHostName = () => isSSR() ? SLETAT_HOST_NAME_PRIVATE  : SLETAT_HOST_NAME_PUBLIC;

export const SLETAT_HOTELS_HOST_NAME = isProd ? 'hotels.sletat.ru' : 'hotelsdebug.sletat.ru';
export const UI_SLETAT_API_HOST_NAME = isProd ? 'ui.sletat.ru' : 'uidev.sletat.ru';
export const API_SLETAT_HOST_NAME = isProd ? 'api.sletat.ru' : 'apidebug.sletat.ru';
export const API_CMS_HOST_NAME = isProd ? 'api-cms.sletat.ru' : 'api-cmsdebug.sletat.ru';
export const MARKUP_HOST_NAME = isProd ? 'markup.sletat.ru' : 'markupdebug.sletat.ru';
export const FRONT_HOST_NAME = isProd ? 'front.sletat.ru' : 'frontdebug.sletat.ru';
export const STATIC_HOST_NAME = 'static.sletat.ru';
export const HOTEL_HOST_PHOTO_STORAGE = isProd ? 'hotels-room.sletat.ru' : 'hotels-room-debug.sletat.ru';
